
<div *ngIf="loadingState$ | async as loadingState">
  <div class="form-container" *ngIf="!loadingState.loading">
    <h1 class="ion-text-center ion-margin-bottom">Sube tu factura</h1>

    <ion-card class="alert-button" *ngIf="rolesOptionsAllowed && buttonsList">
      <ion-item lines="none" class="alert-item">
        <ion-icon name="alert-circle-outline" slot="start" class="alert-icon"></ion-icon>
        <ion-item lines="none" class="alert-item">
          <p>
            <span *ngIf="buttonsList?.length > 1">
              ¿Quieres unirte y disfrutar de los beneficios?
            </span>
            <span *ngIf="buttonsList?.length === 1">
              ¿Quieres unirte a <strong>{{ buttonsList[0]?.name }}</strong>?
            </span>
            <strong class="unete" (click)="openModalButtons(buttonsList)">
              Únete aquí
            </strong>.
          </p>
        </ion-item>
      </ion-item>
    </ion-card>

    <h6 class="ion-text-center ion-margin-bottom">
      Toma una <b>foto clara</b> de tu factura donde se vean:
      <b>nombre de tienda</b>, <b>NIT</b>, <b>fecha</b>, <b>total</b> y
      <b>productos</b>. <br /><br />
      Si la información no es clara, <b>vuelve a intentarlo</b>. Solo puedes
      subir <b>una foto</b>.
    </h6>

    <div class="ion-text-center ion-margin-top ion-margin-bottom">
      <ion-button expand="full" fill="outline" (click)="takePicture()" [disabled]="images.length === 1">
        <ion-icon name="camera" slot="start"></ion-icon>
          {{
            images.length === 0 ? "Seleccionar Foto de Factura" : "Seleccionar otra Foto de Factura"
          }}
      </ion-button>
      <ion-button expand="full" fill="outline" (click)="goToBillDetails()" *ngIf="adminToken">
        {{ "Subir factura sin foto" }}
      </ion-button>
    </div>

    <ion-grid>
      <ion-row>
        <ion-col *ngFor="let img of images; let i = index" class="bill-container">
          <div [style.background-image]="'url(' + img + ')'">
            <button>
              <ion-icon name="close" (click)="deleteImage(i)"></ion-icon>
            </button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row *ngIf="!loading">
        <ion-col size="8" sizeMd="6" style="margin: auto">
          <ion-button expand="block" class="ion-text-wrap" fill="clear" (click)="goBack()">
            Volver
          </ion-button>
        </ion-col>
        <ion-col size="8" sizeMd="6" style="margin: auto">
          <ion-button expand="block" class="ion-text-wrap" (click)="continue()" [disabled]="images.length === 0">
            Continuar
          </ion-button>
        </ion-col>
        <ion-col size="8" sizeMd="6" style="margin: auto">
          <ion-button expand="block" class="ion-text-wrap" (click)="goToUserDetail()" color="secondary" *ngIf="canViewUserDetail">
            Ver detalle del usuario
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="loading">
        <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto">
          <ion-spinner name="crescent"></ion-spinner>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="bottom-ctas">
      <ion-row>
        <ion-col size="12" sizeMd="6" class="cta-col" *ngIf="isPqrsActive">
          <h3>¿Quieres enviar una PQR?</h3>
          <ion-button (click)="goToPqrs()">Haz click aqui</ion-button>
        </ion-col>
        <ion-col size="12" sizeMd="6" class="cta-col">
          <h3> {{titleText}} </h3>
          <ion-button fill="outline" (click)="goToUpdateData()">
            <ion-icon name="refresh-outline" slot="start"></ion-icon>
            {{ buttonText }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <app-loading
    *ngIf="loadingState.loading"
    [currentPhrase]="loadingState.phrase"
    [currentGif]="loadingState?.gif"
  ></app-loading>
</div>
